// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2201":"4e386c0c","3772":"9e8db6cf","4606":"9e8db6cf","6721":"33299d33","7136":"9e8db6cf","9973":"33299d33"}[chunkId] + ".chunk.css";
};